import { Box, factory, Flex, omitText, Typography } from '@kohler-dsm-library/kohler-core';
import { FavoriteNavFilledIcon, FavoriteNavIcon, LocationIcon, UserIcon } from '@kohler-dsm-library/kohler-icons';
import { clsx } from 'clsx';
import React from 'react';
import { LoginMenu } from '../LoginMenu';
import { StoreMenu } from '../StoreMenu';
import classes from './index.module.scss';

const omitFavoritesCTA = (favoritesCTA) => {
  const { isFilled = false, ...omitFavoritesCTA } = favoritesCTA;
  return { isFilled, omitFavoritesCTA };
};

export const UtilityBarMobile = factory((props, ref) => {
  const { utilityLinks, className, requestAppointmentCTA, ...rest } = props;
  const {
    userCTA,
    locationPickerCTA,
    favoritesCTA,
    userName,
    isLoggedIn,
    utilityLinksMobile,
    menuType,
    storeMenu,
    loginMenu,
    setIsOpenMobileMenu,
    setMenuType,
    userCTAMobile,
  } = utilityLinks || {};

  return (
    <Flex className={clsx(classes.utilityBarOverlayMobile, className)} ref={ref} {...rest}>
      <Flex direction="column" gap={20} paddingTop={20} paddingBottom={20}>
        {/* User CTA (desktop-like) */}
        {userCTA && !userCTAMobile && (
          <Box
            component="button"
            type="button"
            textColor="var(--content-primary)"
            aria-label={isLoggedIn ? 'user sign in' : 'profile'}
            {...userCTA}
            onClick={(e) => {
              userCTA?.onClick?.(e);
            }}
          >
            <Flex gap={5} align="center" component="span">
              <UserIcon withBoundingBox />
              <Typography size="navigation-s" component="span" textColor="var(--content-primary)">
                {userCTA.text ? userCTA.text : isLoggedIn && userName ? `Hi, ${userName}` : 'Sign in / Create Account'}
              </Typography>
            </Flex>
          </Box>
        )}

        {/* User CTA Mobile */}
        {userCTAMobile && (
          <>
            {!isLoggedIn && (
              <Box textColor="var(--content-primary)" className={classes.userCTAMobileWrapper}>
                <Flex
                  gap={5}
                  align="center"
                  component="button"
                  type="button"
                  onClick={(e) => {
                    const userCTAOnClick = userCTAMobile?.signInCTA?.onClick;
                    if (!userCTAOnClick) {
                      userCTA?.onClick?.(e);
                    } else {
                      userCTAOnClick(e);
                    }
                  }}
                  {...omitText(userCTAMobile.signInCTA)}
                >
                  <UserIcon withBoundingBox />
                  <Typography size="navigation-s" component="div" textColor="var(--content-primary)">
                    {userCTAMobile.signInCTA.text || 'Sign in'}
                  </Typography>
                </Flex>
                <Typography size="navigation-s" component="span" textColor="var(--content-primary)">
                  /
                </Typography>
                <Typography
                  size="navigation-s"
                  component="button"
                  type="button"
                  textColor="var(--content-primary)"
                  onClick={(e) => {
                    const userCTAOnClick = userCTAMobile?.signUpCTA?.onClick;
                    if (!userCTAOnClick) {
                      userCTA?.onClick?.(e);
                    } else {
                      userCTAOnClick(e);
                    }
                  }}
                  {...omitText(userCTAMobile.signUpCTA)}
                >
                  {userCTAMobile.signUpCTA.text || 'Create Account'}
                </Typography>
              </Box>
            )}
            {isLoggedIn && (
              <Box
                component="button"
                type="button"
                textColor="var(--content-primary)"
                {...userCTAMobile.accountCTA}
                onClick={(e) => {
                  const userCTAOnClick = userCTAMobile?.accountCTA?.onClick;
                  if (!userCTAOnClick) {
                    userCTA?.onClick?.(e);
                  } else {
                    userCTAOnClick(e);
                  }
                }}
              >
                <Flex gap={5} align="center" component="span">
                  <UserIcon withBoundingBox />
                  <Typography size="navigation-s" component="span" textColor="var(--content-primary)">
                    {userCTAMobile.accountCTA.text || `Hi, ${userName}`}
                  </Typography>
                </Flex>
              </Box>
            )}
            {menuType && loginMenu && (
              <Box display={menuType !== 'user' ? 'none' : undefined} className={classes.menuPositionWrapper}>
                <LoginMenu {...loginMenu} setMenuType={setMenuType} setIsOpenMobileMenu={setIsOpenMobileMenu} />
              </Box>
            )}
          </>
        )}

        {/* Utility Links */}
        {/* {utilityLinksMobile &&
          utilityLinksMobile.length > 0 &&
          utilityLinksMobile.map((utilityLink) => (
            <Box
              key={utilityLink.text}
              component="a"
              textColor="var(--content-primary)"
              {...omitText(utilityLink)}
              className={classes.utilityLink}
            >
              <Typography size="navigation-s" component="span" textColor="var(--content-primary)">
                {utilityLink.text}
              </Typography>
            </Box>
          ))} */}

        {/* Location Picker */}
        {locationPickerCTA && (
          <>
            <Flex
              gap={5}
              align="center"
              component="button"
              {...locationPickerCTA}
              onClick={(e) => {
                locationPickerCTA?.onClick?.(e);
              }}
            >
              <LocationIcon withBoundingBox />
              <Typography size="navigation-s" component="span" textColor="var(--content-primary)">
                {locationPickerCTA.text || 'Find a Store'}
              </Typography>
            </Flex>
            {menuType && storeMenu && (
              <Box display={menuType !== 'store' ? 'none' : undefined} className={classes.menuPositionWrapper}>
                <StoreMenu {...storeMenu} setMenuType={setMenuType} setIsOpenMobileMenu={setIsOpenMobileMenu} />
              </Box>
            )}
          </>
        )}

        {requestAppointmentCTA && (
          <Flex
            component={requestAppointmentCTA.href ? "a" : "button"}
            href={requestAppointmentCTA.href}
            target={requestAppointmentCTA.target}
            align="center"
            gap={5}
            aria-label="request appointment"
            textColor="var(--content-primary)"
            {...omitText(requestAppointmentCTA)}
            className={classes.requestAppointmentCTA}
            style={{ justifyContent: 'flex-start' }}
          >
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="16" viewBox="0 0 16 16" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M7.58105 0.207107C7.82651 0.207107 8.03066 0.383982 8.073 0.617231L8.08105 0.707107L8.08105 14.4564C8.08105 14.7325 7.8572 14.9564 7.58105 14.9564C7.33559 14.9564 7.13145 14.7795 7.08911 14.5463L7.08105 14.4564L7.08105 0.707107C7.08105 0.430964 7.30491 0.207107 7.58105 0.207107Z" fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M14.956 7.58179C14.956 7.33633 14.7791 7.13218 14.5459 7.08984L14.456 7.08179L0.706681 7.08179C0.430539 7.08179 0.206682 7.30565 0.206682 7.58179C0.206681 7.82725 0.383556 8.0314 0.616805 8.07373L0.706681 8.08179L14.456 8.08179C14.7321 8.08179 14.956 7.85793 14.956 7.58179Z" fill="white"/>
              </svg>
            </span>
            <Typography size="navigation-s" component="span" textColor="var(--content-primary)">
              {requestAppointmentCTA.text || 'Request Appointment'}
            </Typography>
          </Flex>
        )}
      </Flex>

    </Flex>
  );
});
